import { toast } from "react-toastify"

type Type = 'success' | 'info' | 'error' | 'warn';

export const notify = (text: string, type: Type) => toast[type](text);